import { clientRoutes } from "helpers/clientRoutes";
import { getUrlParam } from "helpers/commonHelpers";
import { ICONS_PATHS } from "helpers/constants";
import { GenerateIcon } from "helpers/iconGenerator";
import useCircle from "hooks/useCircle";
import { useAuth } from "hooks/authHooks";
import { ParsedUrlQuery } from "querystring";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import styles from "./Navigation.module.scss";
import { SignedinState } from "components/enums/SignedinState";
import useMobileDetect from "helpers/useMobileDetect";
import { dataLayerTracking } from "gtmTracking";

const iconPathsCovid = ICONS_PATHS.slice(0, 8);

export interface NavigationProps {
  query?: ParsedUrlQuery;
}

type MenusList = {
  menuItem: string;
  menuIcon: string;
  menuSubTitle?: string;
  targetUrl: string;
  isWebView?: boolean;
  displayMode: Array<number>;
  largeText: boolean;
  genrateIcon: boolean;
  pathNameLink: string;
  action: boolean;
};

const Navigation: React.FC<NavigationProps> = (props) => {
  const { isSignedIn } = useAuth();
  const { isUserCircle, isCircleExpired } = useCircle();
  const [reqParamsForTeams, setReqParamsForTeams] = useState<string | null>(
    null
  );
  const router = useRouter();
  const { query } = props;
  const circleLink =
    isUserCircle || isCircleExpired
      ? clientRoutes.careMembership()
      : clientRoutes.careLanding();
  const { isMobile } = useMobileDetect();

  const menus: MenusList[] = [
    {
      menuItem: "Home",
      menuIcon: "icon-ic_home",
      targetUrl: "/",
      isWebView: true,
      displayMode: [0],
      largeText: false,
      genrateIcon: false,
      pathNameLink: "",
      action: false,
    },
    {
      menuItem: "Insurance",
      menuIcon: "icon-insurance",
      menuSubTitle: "Compare Insurance",
      targetUrl: `${clientRoutes.insurance()}`,
      displayMode: [0],
      largeText: false,
      genrateIcon: true,
      pathNameLink: "",
      action: true,
    },
    {
      menuItem: "Consult",
      menuIcon: "icon-ic-consult",
      menuSubTitle: "Consult Online",
      targetUrl: `${clientRoutes.specialityListing()}`,
      displayMode: [1],
      largeText: true,
      genrateIcon: true,
      pathNameLink: "",
      action: false,
    },

    {
      menuItem: "Consult",
      menuIcon: "icon-ic-consult",
      menuSubTitle: "Consult Online",
      targetUrl: `${clientRoutes.specialityListing()}`,
      displayMode: [0],
      largeText: false,
      genrateIcon: false,
      pathNameLink: "",
      action: false,
    },
    {
      menuItem: "Medicines",
      menuIcon: "icon-ic_medicines",
      menuSubTitle: "Medicines & other products",
      targetUrl: `${clientRoutes.medicines()}`,
      displayMode: [0, 1],
      largeText: true,
      genrateIcon: false,
      pathNameLink: "",
      action: true,
    },
    {
      menuItem: "Lab Tests",
      menuIcon: "icon-ic_tests",
      menuSubTitle: "Health check-ups",
      targetUrl: `${clientRoutes.tests()}`,
      displayMode: [0, 1],
      largeText: false,
      genrateIcon: false,
      pathNameLink: "",
      action: false,
    },
    {
      menuItem: "Circle",
      menuIcon: "icon-mweb-circle",
      menuSubTitle: "Free Delivery & Cashback",
      targetUrl: circleLink,
      displayMode: [0, 1],
      largeText: true,
      genrateIcon: true,
      pathNameLink: "",
      action: false,
    },
    {
      menuItem: "Health Records",
      menuIcon: "icon-ic_myhealth",
      targetUrl: `${clientRoutes.healthRecords("")}`,
      displayMode: [1],
      largeText: false,
      genrateIcon: true,
      pathNameLink: "iconPathsMyhealth",
      action: true,
    },
    {
      menuItem: "Insurance",
      menuIcon: "icon-insurance",
      menuSubTitle: "Compare Insurance",
      targetUrl: `${clientRoutes.insurance()}`,
      displayMode: [1],
      largeText: false,
      genrateIcon: true,
      pathNameLink: "",
      action: true,
    },
    {
      menuItem: "Login",
      menuIcon: "icon-ic_account1",
      targetUrl: "",
      displayMode: [],
      largeText: false,
      genrateIcon: false,
      pathNameLink: "",
      action: false,
    },

    {
      menuItem: "My Account",
      menuIcon: "icon-ic_account1",
      menuSubTitle: "",
      targetUrl: `${clientRoutes.myAccount()}`,
      displayMode: [],
      largeText: false,
      genrateIcon: false,
      pathNameLink: "",
      action: false,
    },
  ];
  useEffect(() => {
    if (isSignedIn === SignedinState.SIGNEDIN) {
      const reqParamsForTeams =
        getUrlParam("utm_source") === "MSTeams"
          ? `?utm_source=MSTeams&t=${encodeURIComponent(getUrlParam("t"))}`
          : null;
      setReqParamsForTeams(reqParamsForTeams);
    }
  }, [isSignedIn]);

  const handleClickMenuItems = (item: MenusList) => {
    dataLayerTracking({
      event: "mega_menu_click",
      menu_name: item?.menuItem,
    });
  };

  const menuRenderList = (currentItem: MenusList, index) => {
    return (
      <li
        key={index}
        onClick={() => handleClickMenuItems(currentItem)}
        className={`${
          currentItem.displayMode.includes(0) && currentItem.largeText
            ? styles.addOn
            : ""
        }
            ${
              currentItem.displayMode.includes(1) &&
              isSignedIn === SignedinState.SIGNEDIN
                ? styles.menuTitle
                : ""
            }
            ${
              currentItem.targetUrl === clientRoutes.welcome()
                ? styles.active
                : ""
            }
            ${currentItem.isWebView ? styles.webview : ""}
            `}
      >
        {currentItem?.action ? (
          <a
            href={currentItem?.targetUrl}
            onClick={(e) => window.location.href}
          >
            {!currentItem?.genrateIcon ? (
              <i className={`${currentItem?.menuIcon} ${styles.menuicon}`} />
            ) : (
              <GenerateIcon
                pathName={iconPathsCovid}
                iconClass={`${currentItem?.menuIcon} ${styles.menuicon}`}
              />
            )}
            <p>{currentItem?.menuItem}</p>
            {(isSignedIn === SignedinState.SIGNEDOUT ||
              isSignedIn === SignedinState.UNRESOLVED) && (
              <span className={styles.subTitle}>
                {currentItem?.menuSubTitle}
              </span>
            )}
          </a>
        ) : (
          <a
            onClick={() => {
              router.push(currentItem?.targetUrl);
            }}
          >
            {!currentItem?.genrateIcon ? (
              <i className={`${currentItem?.menuIcon} ${styles.menuicon}`} />
            ) : (
              <GenerateIcon
                pathName={iconPathsCovid}
                iconClass={`${currentItem?.menuIcon} ${styles.menuicon}`}
              />
            )}
            <p>{currentItem?.menuItem}</p>
            {(isSignedIn === SignedinState.SIGNEDOUT ||
              isSignedIn === SignedinState.UNRESOLVED) && (
              <span className={styles.subTitle}>
                {currentItem?.menuSubTitle}
              </span>
            )}
          </a>
        )}
      </li>
    );
  };

  return (
    <ul className={styles.navigationList}>
      {isSignedIn === SignedinState.SIGNEDIN &&
        menus
          .filter((item) => item.displayMode.includes(1))
          .map((currentItem: MenusList, index) =>
            menuRenderList(currentItem, index)
          )}
      {(isSignedIn === SignedinState.SIGNEDOUT ||
        isSignedIn === SignedinState.UNRESOLVED) &&
        menus
          .filter((item) => item.displayMode.includes(0))
          .map((currentItem: MenusList, index) =>
            menuRenderList(currentItem, index)
          )}
    </ul>
  );
};

export default Navigation;
